import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/information.svg";
var InformationSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  InformationSolid_default as default
};
